import service from '@/services/system/SystemService'

export const systemModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    system: null,
    moeda: process.env.VUE_APP_MOEDAPRINCIPAL ?? 0,
  },
  mutations: {
    SET_SYSTEM(state, payload) {
      state.system = payload
    },
  },
  actions: {
    async getSystem({ commit }, filial) {
      const res = await service.getSystem(filial)
      await commit('SET_SYSTEM', res)
    },
    async clearSystem({ commit }) {
      await commit('SET_SYSTEM', null)
    },
  },
  getters: {
    getSystem: (state) => {
      return state.system
    },
    getSystemCurrencies: (state) => {
      // if (!store.state.authModule.authUser) return
      let currencies = []
      if (state.system) {
        for (let i = 0; i < 6; i++) {
          if (state.system[`MOEDA${i}`]) {
            let currencyObject = {
              descricao: state.system[`MOEDA${i}`] || `Moeda ${i}`,
              mascara: state.system[`MASCARA${i}`] || '',
              cifrao: state.system[`CIFRAO${i}`] || '',
              sinal: state.system[`SINAL${i}`] || '',
              principal: state.system['MOEDAPRINCIPAL'] == i,
              show: state.system[`CIFRAO${i}`] ? true : false,
              index: i,
            }

            currencies[i] = currencyObject
          }
        }
        return currencies
      }
    },
  },
}
